// NATIVE 
import React, { useEffect, useState } from 'react'


// INSTALLED 
import { useDispatch } from 'react-redux';
import { Breadcrumbs, Button, Divider, Typography } from '@mui/material';


// CUSTOM 
import { getShiftsStore } from '../../store/shifts';
import { hasPemissions } from '../../commons/utils';
import { showIconRequestErrors } from '../../store/errors';
import { TableTurnos } from '../../components/tables/TableTurnos';
import { MessagesDrawerRight } from '../../components/MessagesDrawerRight';
import { CreateDialogTurno } from '../../components/modals/turnos/CreateDialogTurno';
import { SnackAlert } from '../../components/SnackAlert';
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle';
import { mtDividerUpTable } from '../../commons';
import { AlertsInformativos } from '../../components/generics/AlertsInformativos';
import { alertInformativo } from '../../commons/texts';




export const Turnos = () => {


    // DISPATCH 
    const dispatch = useDispatch();


    // USE STATE 
    const [data, setMsgErrors] = useState([]);
    const [openTurno, setOpenTurno] = useState(false);
    const [canCreate, setCanCreate] = useState(false);


    const [alert_snack, setAlertSnack] = React.useState(false);
    const [msgSnack, setMsgSnack] = React.useState({
        msg: '',
        status: 'success'
    });


    // USE EFECT 
    useEffect(() => {
      canCheckCanCreate();
    }, []);
    
    
    const canCheckCanCreate = async () => {
         
      const havePermissions = await hasPemissions('modulo.thumano', 'modulo.turnos', 'create');

      setCanCreate(havePermissions);

    }

    const openModal = async() => {

        // modulo.turnos                             nombre modulo     sub modulo    permission
        const havePermissions = await hasPemissions('modulo.thumano', 'modulo.turnos', 'create');


        if( !havePermissions ){


          await validateLsPermissions('No tienes pemisos para (Crear) turnos.');

          return false; 
  
                                                                       
           
        }
         
         setOpenTurno(true)
    }
  
    const handleCloseDialogCrearTurno = () => {
          setOpenTurno(false)
    }


    


    const validateLsPermissions = async(message:string) => {

      const errors:any = {
        msg: message,
        status: 'error'
      };
    
      await setMsgSnack(errors);
      await setAlertSnack(true);
    
    
    }


  return (


    <>

   
        <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>


        <BreadCrumbsAndTitle
                        title="Listado Turnos" 
                        mainModule="Talento Humano" 
                        parent="Listado Turnos"
                        action="" />

        <div style={{ display: 'flex', justifyContent: 'end'}}>
          {
             canCreate && <Button   variant='contained' sx={{ marginBottom: 3 }} onClick={openModal}>Crear Turno</Button>
          }
        </div>

        <AlertsInformativos type={'info'} title={'info'} content={alertInformativo.turnos} />
        <Divider sx={{ marginBottom: mtDividerUpTable }}/>
        
         <CreateDialogTurno open={openTurno} handleCloseDialogCrearTurno={handleCloseDialogCrearTurno} />
         <TableTurnos /> 
    </>

  )
}
